import { AlertCircle, CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AlertMessageProps {
  type: 'error' | 'success'
  message: string
  className?: string
  id?: string
  'aria-live'?: 'polite' | 'assertive' | 'off'
}

/**
 * Reusable alert message component for errors and success messages
 */
export function AlertMessage({
  type,
  message,
  className,
  id,
  'aria-live': ariaLive = 'assertive',
}: AlertMessageProps) {
  const isError = type === 'error'

  return (
    <div
      id={id}
      role="alert"
      aria-live={ariaLive}
      className={cn(
        'flex items-center gap-3 text-sm rounded-xl px-4 py-3.5 border-2 shadow-sm animate-in fade-in slide-in-from-top-2 duration-300',
        isError
          ? 'text-red-700 bg-gradient-to-br from-red-50 to-red-100/50 border-red-300 shadow-red-100/50'
          : 'text-green-700 bg-gradient-to-br from-green-50 to-green-100/50 border-green-300 shadow-green-100/50',
        className
      )}
    >
      {isError ? (
        <AlertCircle className="w-5 h-5 flex-shrink-0 text-red-600" aria-hidden="true" />
      ) : (
        <CheckCircle2 className="w-5 h-5 flex-shrink-0 text-green-600" aria-hidden="true" />
      )}
      <span className="font-medium">{message}</span>
    </div>
  )
}
